
export const pathFromAssetURL = (assetURL: string): string => {
    const u = URL.parse(assetURL)
    if (!u) {
        throw `expected asset URL ${assetURL} to be a valid path`
    }
    return u.pathname
}

export const isAssetURLExpired = (url: string, expiryLeeway: number = 0): boolean => {
    const u = URL.parse(url)
    const expires = u?.searchParams.get("Expires")
    if (!expires) {
        return false
    }
    return parseInt(expires) - expiryLeeway < Date.now() / 1000
}
